import { render, staticRenderFns } from "./ocrTemplateConfig.vue?vue&type=template&id=1efc16da&"
import script from "./ocrTemplateConfig.vue?vue&type=script&lang=js&"
export * from "./ocrTemplateConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1efc16da')) {
      api.createRecord('1efc16da', component.options)
    } else {
      api.reload('1efc16da', component.options)
    }
    module.hot.accept("./ocrTemplateConfig.vue?vue&type=template&id=1efc16da&", function () {
      api.rerender('1efc16da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SystemMaintenance/components/ocr/ocrTemplateConfig.vue"
export default component.exports